<template>
  <div  class="h-8 w-36">
    <img src="@/assets/ubook-logo.svg" alt="ubook-logo" height="100%" />
  </div>
</template>
